import { Component, inject } from '@angular/core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { AuthStore, GovernorateApiService } from '@core';
import { GovernorateItem } from '@models';
import { switchMap } from 'rxjs';

@Component({
  selector: 'lib-governorates',
  imports: [CacTableComponent],
  templateUrl: './governorates.component.html',
  styleUrl: './governorates.component.scss',
})
export class GovernoratesComponent {
  private readonly governorateApi = inject(GovernorateApiService);
  private readonly authStore = inject(AuthStore);

  table = table({
    itemsFn: this.governorateApi.getAdapter(),
    view: { 
      itemName: 'Governorate',
      title: 'Governorates'
    },
    columns: {
      id: { label: 'ID' },
      'name.english': {
        label: 'English Name',
        sortable: 'EnglishName',
        filterable: 'EnglishName'
      },
      'name.arabic': {
        label: 'Arabic Name',
        sortable: 'ArabicName',
        filterable: 'ArabicName'
      },
      price: {
        label: 'Shipping Fee',
        transform: (value: number) => `${value} KWD`,
        sortable: true
      },
    },
    actions: [
      {
        type: 'icon' as const,
        content: 'edit',
        action: (item: GovernorateItem) =>
          this.governorateApi.getGovernorate(item.id).pipe(
            switchMap(governorate => dialog$.governorate({
              governorate,
              governorateItem: item
            }).afterSubmit())
          ),
      },
      ...(!this.authStore.isRestrictedAdmin() ? [{
        type: 'icon' as const,
        content: 'trash',
        action: (item: GovernorateItem) => {
          return dialog$
            .deletePrompt(false, { itemName: item.name?.english || `Governorate ${item.id}` })
            .action(() => this.governorateApi.delete(item.id));
        },
      }] : []),
    ],
    events: {
      add: () => dialog$.governorate({}).afterSubmit()
    },
  });
}
